export enum Platform {
  CustomerWebsite = "CustomerWebsite",
  Admin = "Admin",
  B2BAPI = "B2BAPI",
  CareTracka = "CareTracka",
  OrganisationDashboard = "OrganisationDashboard",
  CustomerMobile = "CustomerMobile",
}
